import { DeliveryMode } from '../../../../../services/exports/Constants';

export default {
  title: 'Bezorgstructuur',
  subtitle: 'Kies hoe bestellingen worden bezorgd (per locatie).',
  form: {
    delivery_mode: {
      label: 'Bezorgmodus',
      placeholder: 'Selecteer bezorgmodus',
      options: {
        [DeliveryMode.Internal]: 'Intern (eigen chauffeurs)',
        [DeliveryMode.External]: 'Extern (derde partij)',
      },
    },
  },
  buttons: {
    back: 'Terug',
    next: 'Volgende',
    skip: 'Overslaan',
  },
  toasts: {
    error: 'Er is iets misgegaan. Probeer het opnieuw.',
  },
};
